module.exports = "/_next/static/images/Cover-7d4a0001cf8ffa734481da5a78b4a876.webp";